import React from 'react';
import Link from 'next/link';
import styled from '@emotion/styled';

export const PreviewModeBanner = () => {
  return (
    <Outer>
      <BannerWrapper>
        You are in preview mode!{' '}
        <Link href="/api/preview-disable">Exit preview mode</Link>
      </BannerWrapper>
    </Outer>
  );
};

const Outer = styled.div`
  background-color: #f2f2f2;
  padding: 10px;
  display: flex;
  justify-content: center;
`;

const BannerWrapper = styled.div`
  grid-template-columns: 1fr auto auto;
  display: grid;
  margin: 0 10px;
  width: 100%;
`;
